const HOME_AI_VALUE_LOOP_EN = {
  introTitle: 'Thinking about AI in production?',
  introLede: 'So are we, and we have a method for it.',
  title: 'The AI Value Loop',
  body:
    'Most AI projects stall between proof-of-concept and production. Our AI Value Loop method is how we close that gap: a repeatable cycle that validates, builds and deploys AI use cases that deliver measurable outcomes, run by a senior team embedded in your organization.',
  cta: {
    label: 'Know How it Works',
    href: '/en/enterprise-ai/',
  },
  highlights: [
    {
      id: 'loop',
      text: 'Discover → Build → Deploy → Operate & Scale',
    },
    {
      id: 'team',
      text: 'Senior team embedded in your workflows',
    },
    {
      id: 'compliance',
      text: 'Compliance and security built in',
    },
  ],
}

const HOME_AI_VALUE_LOOP_PT = {
  introTitle: 'A pensar em IA em produção?',
  introLede: 'Nós também, e temos um método para isso.',
  title: 'O AI Value Loop',
  body:
    'A maioria dos projetos de IA ficam bloqueados entre a prova de conceito e produção. O nosso método AI Value Loop é como fechamos essa lacuna: um ciclo repetível que valida, constrói e implementa casos de uso de IA com resultados mensuráveis, executado por uma equipa sénior integrada na sua organização.',
  cta: {
    label: 'Saiba como funciona',
    href: '/ia-empresarial/',
  },
  highlights: [
    {
      id: 'loop',
      text: 'Descobrir → Construir → Implementar → Operar e Escalar',
    },
    {
      id: 'team',
      text: 'Equipa sénior integrada nos seus fluxos de trabalho',
    },
    {
      id: 'compliance',
      text: 'Conformidade e segurança incorporadas',
    },
  ],
}

export const getHomeAIValueLoopContent = lang =>
  lang === 'pt' ? HOME_AI_VALUE_LOOP_PT : HOME_AI_VALUE_LOOP_EN
